<template>
  <v-layout>
    <v-flex v-if="document">
      <v-toolbar class="elevation-0" :height="40">
        <h4>Файл: {{ document.name }}
          <span v-if="document.is_archived" class="grey--text">(В архиве)</span>
          <span v-else-if="document.status == 'pending'" class="grey--text">(Загружен)</span>
          <span v-else-if="document.status == 'sent'" class="grey--text">(Отправлен)</span>
          <span v-else-if="document.status == 'inbox'" class="grey--text">(Получен)</span>
        </h4>
      </v-toolbar>
      <v-toolbar class="elevation-0" :height="40">
        <v-btn @click="fetchData()" small>
          Обновить
          <v-icon right small>mdi-refresh</v-icon>
        </v-btn>
        <v-btn v-if="!document.is_shared" @click="shareDocument()" small>
          Поделиться ссылкой
          <v-icon right small>mdi-share-variant</v-icon>
        </v-btn>
        <v-btn v-else @click="unshareDocument()" small>
          Скрыть
          <v-icon right small>mdi-eye-off-outline</v-icon>
        </v-btn>
        <v-btn v-if="document.status == 'pending'" @click="send_dialog = true" small>
          Отправить
          <v-icon right small>send</v-icon>
        </v-btn>
        <v-btn small @click.native="sign_dialog = true">
          Подписать
          <v-icon right small>mdi-lead-pencil</v-icon>
        </v-btn>
        <v-btn v-if="document.status == 'pending' || document.is_archived"
               @click="delete_dialog = true" small>
          Удалить
          <v-icon right small>delete</v-icon>
        </v-btn>
        <v-btn v-else-if="document.status == 'inbox' || document.status == 'sent'"
               @click="archiveDocument()"
               small>
          Перенести в архив
          <v-icon right small>mdi-zip-box</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <div v-if="loading"></div>
        <v-layout row v-else>
          <v-flex xs12 lg8 xl8>
            <DocumentViewer v-if="document" :document="document" :is_shared="false" />
          </v-flex>
          <v-flex pa-2 lg4 xl4>
            <v-btn v-if="document" :href="addToken(document.original_url)" block>
              Скачать оригинал
            </v-btn>
            <v-btn v-if="document && document.signs.length > 0" :href="addToken(document.archive_url)" block>
              Скачать архив с подписями
            </v-btn>
            <h3>Подписи:</h3>
            <v-card class="mb-2" v-for="sign in document.signs" :key="'sign_'+sign.drfo+sign.edrpou" >
              <v-card-title>
                <div>
                <span><b>Организация:</b> {{ sign.organization }}</span><br>
                <b>ФИО:</b> {{ sign.name }}<br>
                <template v-if="sign.edrpou"><b>ЕДРПОУ:</b> {{ sign.edrpou }}<br></template>
                <template v-if="sign.drfo"><b>ДРФО:</b> {{ sign.drfo }}<br></template>
                <template v-if="sign.title"><b>Должность:</b> {{ sign.title }}<br></template>
                <b>Дата/Время подписи:</b> {{ sign.created_at | date }}<br>
                <b>Файл подписи: </b> <a :href="addToken(sign.url)">Скачать</a>
                </div>
              </v-card-title>
            </v-card>
            <p v-if="document.signs.length == 0">Выбранный документ не имеет ЭЦП.</p>
            <h3 v-if="document.status === 'inbox'">Отправитель:</h3>
            <h3 v-if="document.status === 'sent'">Получатель:</h3>
            <v-card v-if="document.status === 'sent' || document.status === 'inbox'">
              <v-card-title>
                <div v-if="document.status === 'inbox'">
                  <span v-if="document.sender_edrpou !== ''"><b>ЕДРПОУ:</b> {{document.from_edrpou}}</span><br>
                  <span v-if="document.sender_drfo !== ''"><b>ДРФО:</b> {{document.from_drfo}}</span><br>
                </div>
                <div v-if="document.status === 'sent'">
                  <span v-if="document.receiver_edrpou !== ''"><b>ЕДРПОУ:</b> {{document.receiver_edrpou}}<br></span>
                  <span v-if="document.receiver_drfo !== ''"><b>ДРФО:</b> {{document.receiver_drfo}}<br></span>
                </div>
              </v-card-title>
            </v-card>

          </v-flex>
        </v-layout>
      </v-card>
      <DocumentShareDialog v-model="share_dialog" :document="document" @close="share_dialog = false" />
      <DocumentDeleteDialog v-model="delete_dialog" :document="document" @close="delete_dialog = false"
                           @done="onDelete()" />
      <DocumentSignDialog v-model="sign_dialog" :document="document" @close="sign_dialog = false" @done="fetchData()" />
      <DocumentSendDialog v-model="send_dialog" :document="document" @close="send_dialog = false" @done="fetchData()" />
    </v-flex>
  </v-layout>
</template>

<script>
import DocumentViewer from '@/components/DocumentViewer'
import DocumentSignDialog from '@/components/DocumentSignDialog'
import DocumentDeleteDialog from '@/components/DocumentDeleteDialog'
import DocumentSendDialog from '@/components/DocumentSendDialog'
import DocumentShareDialog from '@/components/DocumentShareDialog'


export default {
  name: 'DocumentDetail',
  props: ['mode'],
  components: {
    DocumentViewer,
    DocumentSignDialog,
    DocumentDeleteDialog,
    DocumentSendDialog,
    DocumentShareDialog
  },
  data () {
    return {
      view_url: '',
      document: null,
      loading: true,
      send_dialog: false,
      sign_dialog: false,
      delete_dialog: false,
      share_dialog: false
    }
  },
  methods: {
    onDelete() {
      this.$router.push({ name: this.mode+'_document_list' })
    },
    archiveDocument() {
      this.$store.dispatch('archiveDocument', this.$route.params.document_id)
        .then(() => {
          this.fetchData()
        })
    },
    shareDocument() {
      this.$store.dispatch('shareDocument', this.$route.params.document_id)
        .then((response) => {
          this.document = response.data
        })
        .then(() => {
          this.share_dialog = true
        })
    },
    unshareDocument() {
      this.$store.dispatch('unshareDocument', this.$route.params.document_id)
        .then((response) => {
          this.document = response.data
        })
    },
    fetchData() {
      this.$store.dispatch('getDocumentById', this.$route.params.document_id)
        .then((response) => {
          this.document = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    addToken(val) {
      return `${val}?access_token=`+localStorage.getItem('token')
    }
  },
  created () {
    this.$store.dispatch('getCertificateList')
    this.$store.dispatch('getProfile')
    this.fetchData()
  }
}
</script>
